<template>
    <div class="artist-select">
        <el-select ref="artist-select" v-model="value" value-key="artistId" :multiple="true" :filterable="true"
            :remote="true" :disabled="disabled" :remote-method="remote" :loading="remoteLoading" style="width: 100%;"
            :placeholder="placeholder">
            <!-- 区域1：新增按钮 -->
            <div v-if="hasSearchQuery && !remoteLoading" class="add-button-container">
                <el-button type="primary" size="small" @click.stop="add">
                    新增一个
                </el-button>
            </div>
            
            <!-- 区域2：查询结果 -->
            <div class="results-container">
                <el-option v-for="item in remoteOptions" :key="item.artistId" :label="item.artistName" :value="item" :disabled="item.disabled">
                    <span v-if="item.searchHitName">
                        {{ item.artistName }} <span style="color: #909399">({{ item.searchHitName }})</span>
                    </span>
                    <span v-else>{{ item.artistName }}</span>
                </el-option>
            </div>
            
            <p slot="empty" class="el-select-dropdown__empty">
                <span v-show="remoteLoading">加载中</span>
                <span v-show="!remoteLoading && !hasSearchQuery">无相关艺人</span>
            </p>
        </el-select>
        <artist-add-dialog :dialog-visible.sync="artistAddDialogVisible" :artist-name="artistName"
            @add-success="addSuccessCallback" />
        <AddArtist :visible.sync="addVisible" @add-success="addSuccessCallback"></AddArtist>
    </div>
</template>

<script>
import ArtistAddDialog from '../ArtistAddDialog';
import AddArtist from '../AddArtist';
import { fetchArtistByName } from '@/api/common';
export default {
    components: {
        ArtistAddDialog,
        AddArtist
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '请输入关键词'
        }
    },
    data() {
        return {
            remoteOptions: [],
            remoteLoading: false,
            artistName: '',
            artistAddDialogVisible: false,
            addVisible: false,
            hasSearchQuery: false
        };
    },
    computed: {
        value: {
            get() {
                return this.data;
            },
            set(v) {
                this.$emit('change', v);
            }
        }
    },
    watch: {
        data: {
            handler: function () {
                this.remoteOptions = (this.data || []).map(item => {
                    return { ...item };
                });

                this.$nextTick(() => {
                    this.remoteOptions = [];
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        remote(q) {
            if (!q) {
                this.hasSearchQuery = false;
                return (this.remoteOptions = []);
            }

            this.hasSearchQuery = true;
            this.remoteLoading = true;

            fetchArtistByName(q)
                .then(res => {
                    if (!res.data.state) {
                        throw new Error(res.data.msg);
                    }

                    this.artistName = q;

                    const results = res.data.result || [];
                    if (results.length === 0) {
                        // 添加一个特殊选项来显示"暂无数据"
                        this.remoteOptions = [{ 
                            artistId: 'no-data', 
                            artistName: '暂无数据', 
                            disabled: true 
                        }];
                    } else {
                        this.remoteOptions = results.map(item => {
                            const { name, id, searchHitName } = item;
                            return { artistName: name, artistId: id, searchHitName };
                        });
                    }
                })
                .catch(() => {
                    // 请求失败时也显示"暂无数据"
                    this.remoteOptions = [{ 
                        artistId: 'no-data', 
                        artistName: '暂无数据', 
                        disabled: true 
                    }];
                })
                .finally(() => {
                    this.remoteLoading = false;
                });
        },
        // 新增艺人
        add() {
            this.$refs['artist-select'].blur();
            const { artistName } = this.$store.state.userInfo;
            if (artistName) return (this.artistAddDialogVisible = true);
            this.addVisible = true;
        },
        // 新增艺人回调
        addSuccessCallback(v) {
            const { artistName, artistId } = v;

            this.$emit('change', this.data.concat([{ artistName, artistId }]));
            this.remoteOptions = [{ artistName, artistId }];

            this.$nextTick(() => {
                this.remoteOptions = [];
            });
        }
    }
};
</script>

<style scoped>
/* 区域1：新增按钮 */
.add-button-container {
    padding: 2px;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
}

.add-button-container .el-button {
    width: auto;
    padding: 0 20px;
}

/* 区域2：查询结果 */
.results-container {
    overflow-y: auto;
    max-height: 300px;
}
</style>
